export const EARN = "EARN"
export const SPEND = "SPEND"
